import React from "react";

export const SectionTitle = ({ overline, title, sub, className = "" }) => (
  <div className={`mb-10 ${className}`}>
    {overline && (
      <p className="text-xs tracking-[0.25em] uppercase text-[#FF5722] mb-3 font-semibold">{overline}</p>
    )}
    <h2 className="font-display text-4xl sm:text-5xl uppercase leading-none">{title}</h2>
    {sub && <p className="text-white/60 mt-3 max-w-xl">{sub}</p>}
  </div>
);
